import { useCallback } from 'react'
import type { MouseEvent } from 'react'

export function usePreventGridFocusSteal() {
  return useCallback((event: MouseEvent) => {
    event.preventDefault()
  }, [])
}
